<template>
  <div id="parent" ref="tagCategory" :class="{ fixTagsCategory: scrollFixTop }">
    <div class="tags" :class="{ green }">
      <horizontal-scroll style="overflow-x: hidden;" v-if="categories">
        <category-label v-for="category in categories" :key="category.name" :category="category" />
      </horizontal-scroll>
    </div>
  </div>
</template>

<script async>
import { mapActions, mapGetters } from 'vuex'
import HorizontalScroll from 'vue-horizontal-scroll'
import 'vue-horizontal-scroll/dist/vue-horizontal-scroll.css'

const FoodCategoryLabel = () => import(/* webpackChunkName: "vsf-food-category-label" */ 'theme/components/core/blocks/Header/FoodCategoryLabel');

export default {
  name: 'ProductCategory',
  components: {
    'category-label': FoodCategoryLabel,
    HorizontalScroll
  },
  computed: {
    ...mapGetters({
      categories: 'category/list'
    }),
    scrollTag () {
      if (this.$refs.tagCategory !== undefined) {
        return 260
      }
    }
  },
  data () {
    return {
      scrollFixTop: false,
      green: false
    }
  },
  methods: {
    ...mapActions({
      isPartnerPage: 'ui/togglePartnerPage',
      resetPartner: 'partners/resetCurrentPartner'
    }),
    handleScroll () {
      this.scrollFixTop = window.scrollY > this.scrollTag
      this.$emit('showCategory', this.scrollFixTop === true)
    }
  },
  mounted () {
    if (!this.isLoggedIn && localStorage.getItem('redirect')) {
      this.$bus.$emit('modal-show', 'modal-signup')
    }
    window.addEventListener('scroll', this.handleScroll)
    this.isPartnerPage()
  }
}
</script>

<style lang="scss" scoped>
.green {
  background: green;
}

#parent{
  width: calc(100% - 84px);
}

.fixTagsCategory{
  width: 100% !important;
  position: fixed;
  top: 52px;
  z-index: 1;
  left: 0;
  background: #ffffff;
  overflow: hidden;
  .tags{
    width: 1180px !important;
    margin:0 auto;
    height: 45px;
    @media(max-width:1200px){
      width:100% !important;
    }
  }
}
.material-icons.close{
  font-size: 21px;
  position: absolute;
  right: 0;
  top: -5px;
  color: #000;
  border-radius: 50%;
  background-color: #fff;
}
#home{
  position: relative;
  top: -54px;
  margin-bottom: -54px;
}
.new-collection {
  @media (max-width: 768px) {
    padding-top: 0;
  }
}
.menu-bottom {
  display: block;
  margin-top: -50px;
}
.tags{
  text-align: left;
  &.current{
    .tag-wrap{
      display: none;
      &.active{
        display: inline-flex;
      }
    }
  }
}
.tag-wrap {
  color: #000000;
  height: 35px;
  border-radius: 35px;
  border: 1px solid #11bb2e;
  background-color: #ffffff;
  padding: 0 20px;
  font-size: 14px;
  font-family: "TTNorms Medium", sans-serif;
  &.active {
    background-color: #11bb2e;
    color: #fff;
    fill: #fff;
  }
}
.parent-bred span:nth-last-child(2) .slash{
  display: none;
}
</style>
